import {
  dialog
} from '../base';

isVisitFromEmail();

function isVisitFromEmail() {
  let params = (new URL(document.location)).searchParams;
  let number = params.get('order_number');
  if (number) {
    dialog.open('reviews')
      .then((data) => {
        const modal = data.getElem();
        const input = modal.querySelector('#reviewsOrder');
        input.value = number;
      });
  } else {
    return;
  }
}
